import { render, staticRenderFns } from "./RejectHistory.vue?vue&type=template&id=908c16cc&scoped=true&"
import script from "./RejectHistory.vue?vue&type=script&lang=js&"
export * from "./RejectHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908c16cc",
  null
  
)

export default component.exports